import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useHistory } from 'react-router-dom';
import Loader from './Loader';
import { useDispatch } from 'react-redux';
import {
  deleteBlog,
  AddReplies,
  LoadSingleMsg,
  editReply,
  deleteReply,
} from './actions';
import {
  FaEdit,
  FaTrashAlt,
  FaUserEdit,
  FaThumbsUp,
  FaRegCommentDots,
} from 'react-icons/fa';
import { useBlogContext } from '../Context/BlogContext';

const Blog = () => {
  const { currentUser, blog } = useBlogContext();

  const [reply, setReply] = useState({
    name: '',
    msg: '',
    id: '',
    timestamp: '',
  });

  const [edit, setEdit] = useState(false);

  const [ids, setIds] = useState('');

  const { id } = useParams();
  let history = useHistory();

  let content = 'Page Not  Found';

  const dispatch = useDispatch();

  const handleLikes = (ids) => {
    if (!currentUser.uuid) {
      history.push('/login');
    } else {
      // const add = blog.post.comments.find((item) => item.id === ids);
      // console.log(add);

      const add = blog.post.comments.map((item) =>
        item.id === ids
          ? {
              ...item,
              likes: [
                {
                  name: currentUser.firstName,
                  like: true,
                  uid: currentUser.uuid,
                },
              ],
            }
          : item
      );
      console.log(add);

      // axios({
      //   method: 'PUT',
      //   url: `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
      //   data:

      // );

      // dispatch(
      //   addLikes({
      //     id: id,
      //     data: {
      //       name: currentUser.firstName,
      //       uid: currentUser.uuid,
      //       like: true,
      //     },
      //   })
      // );
    }
  };

  const handleDisLikes = (ids) => {
    const add = blog.post.comments.find((item) => item.id === ids);
    console.log(add);

    // const Adds = add.likes.filter((item) => item.uid !== currentUser.uuid);

    // axios({
    //   method: 'PUT',
    //   url: `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
    //   data: {
    //     ...add,
    //     likes: Adds,
    //   },
    // });

    // dispatch(disLikes({ id: id, data: Adds }));
  };

  const checkLikes = () => {
    console.log('checks');
  };

  useEffect(() => {
    dispatch(
      LoadSingleMsg({
        loading: true,
        post: null,
        error: false,
      })
    );
    id &&
      axios
        .get(`https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`)
        .then((response) => response.data)
        .then((data) => {
          console.log(data);

          dispatch(
            LoadSingleMsg({
              loading: false,
              post: data,
              error: false,
            })
          );
        })
        .catch(() =>
          dispatch(
            LoadSingleMsg({
              loading: false,
              post: null,
              error: true,
            })
          )
        );
  }, [dispatch, id]);

  //We didn't dispatch an action to update state because we launching another component after updates
  const handleDel = (id) => {
    dispatch(deleteBlog(id));
    axios
      .delete(`https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`)
      .then(() => history.push('/'));
  };

  const handleEditReply = (id) => {
    console.log('edited', id);
    setEdit(true);
    setIds(id);

    const editedReply = blog.post.comments.find((post) => post.id === id);
    console.log(editedReply);

    setReply({
      ...reply,
      msg: editedReply.msg,
    });
  };

  const handleDeleteReply = async (ids) => {
    console.log('deleted', ids);

    const newPost = blog.post.comments.filter((post) => post.id !== ids);
    console.log(newPost);

    await axios.put(
      `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
      {
        ...blog.post,
        comments: newPost,
      }
    );
    dispatch(deleteReply(newPost));
  };

  const handleReplies = async (e) => {
    e.preventDefault();
    try {
      if (ids) {
        const editedComment = blog.post.comments.map((post) =>
          post.id === ids ? { ...post, msg: reply.msg, edited: true } : post
        );

        await axios.put(
          `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
          {
            ...blog.post,
            comments: editedComment,
          }
        );

        dispatch(editReply(editedComment));
        setReply({ name: '', msg: '' });
        setIds('');
        setEdit(false);
      }
      if (!ids) {
        await axios.put(
          `https://610fed18c848c900171b3a0f.mockapi.io/api/v1/posts/${id}`,
          {
            ...blog.post,
            comments: [...blog.post.comments, reply],
          }
        );

        dispatch(
          AddReplies({
            ...blog.post,
            comments: [...blog.post.comments, reply],
          })
        );

        setReply({ name: '', msg: '' });
      }
    } catch (error) {
      console.log(error);
    }
  };

  blog.loading && (content = <Loader />);
  blog.error && (content = 'An Error Ocuured, Kindly Refresh Or Try again');

  return (
    <div className='blog  flex min-h-screen '>
      {blog.post ? (
        <div className='w-11/12 mx-auto my-10 flex flex-col gap-5 '>
          <Link to={`/manageBlogs/${blog.post.id}`}>
            <h3 className='text-xl font-bold'>{blog.post.title}</h3>
          </Link>
          <p className='text-gray-500'>{blog.post.content}</p>

          <div className='flex gap-10 items-center '>
            <Link
              className='flex gap-2 items-center  '
              to={`/manageBlogs/${blog.post.id}`}
            >
              Edit <FaEdit />
            </Link>
            <button
              className='flex gap-2 items-center '
              onClick={() => handleDel(blog.post.id)}
            >
              Delete <FaTrashAlt />
            </button>
          </div>

          <div className='flex flex-col gap-3 '>
            {blog.post.comments.map((item, index) => (
              <div
                key={index}
                className='flex flex-col gap-3 bg-white rounded-3xl p-4 '
              >
                {/* <img src={Polygon} className='reply' alt='polygon' /> */}
                <div className='flex justify-between text-base py-1 border-b'>
                  <div className='flex gap-4 items-center'>
                    {currentUser.firstName === item.name ? (
                      <>
                        <span>{item.name} </span>
                        <span>
                          <FaUserEdit />{' '}
                        </span>
                        {item.edited && (
                          <span className='text-gray-300 italic text-xs'>
                            (Edited)
                          </span>
                        )}
                      </>
                    ) : (
                      <>
                        <span>{item.name} </span>

                        {item.edited && (
                          <span className='text-gray-300 italic text-xs'>
                            (Edited)
                          </span>
                        )}
                      </>
                    )}
                  </div>
                  <div className='flex gap-3 text-sm'>
                    <p>{new Date(item.timestamp).toDateString()}</p>
                    <p>{new Date(item.timestamp).toLocaleTimeString()}</p>
                  </div>
                </div>
                <div className='flex justify-between'>
                  <p>{item.msg}</p>
                  {currentUser.firstName === item.name ? (
                    <div className='flex gap-4 cursor-pointer'>
                      <p onClick={() => handleEditReply(item.id)}>
                        <FaEdit />
                      </p>
                      <p onClick={() => handleDeleteReply(item.id)}>
                        {' '}
                        <FaTrashAlt />
                      </p>
                    </div>
                  ) : null}
                </div>

                {/* replies and likes for comments
                 */}

                <div className='flex gap-4'>
                  {checkLikes(currentUser.uuid) ? (
                    <button
                      onClick={() => handleDisLikes(item.id)}
                      className='border rounded-full w-14 px-1 border-gray-400'
                    >
                      <span className='flex items-center text-gray-700  gap-2 p-1 text-sm'>
                        <FaThumbsUp color='#f7b950' /> {0}
                      </span>
                    </button>
                  ) : (
                    <button
                      onClick={() => handleLikes(item.id)}
                      className='border rounded-full w-14 px-1 border-gray-400'
                    >
                      <span className='flex items-center text-gray-700  gap-2 p-1 text-sm'>
                        <FaThumbsUp color='#f7b950' /> {0}
                      </span>
                    </button>
                  )}

                  <Link to={`/blog/${blog.id}`}>
                    <button>
                      <span className='flex items-center text-gray-700  gap-2 p-1 text-sm'>
                        <FaRegCommentDots />
                        reply
                      </span>
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <form onSubmit={handleReplies} className='flex flex-col gap-8'>
            <textarea
              name='content'
              className=' block w-full text-sm rounded-b-3xl bg-white border-transparent px-3 py-2  outline-none'
              placeholder='Leave A Reply'
              rows='10'
              value={reply.msg}
              onChange={(e) =>
                setReply({
                  name: currentUser.firstName,
                  msg: e.target.value,
                  id: Date.now(),
                  timestamp: new Date(),
                })
              }
            ></textarea>

            <div className='flex gap-3 justify-end'>
              <button
                type='button'
                onClick={() => {
                  setIds('');
                  setEdit(false);
                  setReply({ name: '', msg: '', id: '', timestamp: '' });
                }}
                className='bg-red-500 py-2 px-6 text-xs rounded-lg text-white'
              >
                Cancel
              </button>
              <button className='bg-green-600 py-2 px-6 text-xs rounded-lg text-white'>
                {edit ? 'Edit Reply' : 'Reply'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        content
      )}
    </div>
  );
};

export default Blog;
